import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/login.vue";
import HomePage from "../views/homePage.vue";
import NotFound from "../views/404.vue";
import store from "@/store";
Vue.use(VueRouter);

// 不需要用户权限的路由表
const staticRoutes = [
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/404",
    name: "404",
    component: NotFound
  },
  {
    path: "/",

    name: 'homePage',
    component: HomePage,
    children: [
      {
        path: "/detail/:id/:user",
        name: "memberDetail",
        component: () => import("@/views/memberDetail.vue")
      }
    ]
  },
  // {
  //   path: "/depart",
  //   name: 'depart',
  //   component: HomePage,
  //   children: [
  //     {
  //       path: "/depart/departList",
  //       name: "departList",
  //       component: () => import("@/views/departList.vue")
  //     }
  //   ]
  // },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: staticRoutes
});

const getRouter = async (to, next) => {
  await store.dispatch("routeList");

  let arr = [...store.state.sideBarList, {
    path: "*",
    name: "NotFound",
    component: HomePage,
    redirect: "/homePage",
  }]
  router.addRoutes(arr);
  next({ ...to, replace: true });
};

const LOGIN_PAGE_NAME = "login";

router.beforeEach((to, from, next) => {
  const isLogin = !!store.state.userInfo.id
  if (isLogin && to.name == LOGIN_PAGE_NAME) {
    next({ name: 'homePage' });
  }
  if (!isLogin && to.name !== LOGIN_PAGE_NAME) {
    next({ name: LOGIN_PAGE_NAME });
  } else if (to.name === LOGIN_PAGE_NAME) {
    next();
  } else {
    if (!store.state.sideBarList) {
      getRouter(to, next);
    } else {
      if (store.state.sideBarList[0]) {
        if (!store.state.sideBarList[0].component) {
          getRouter(to, next);
          return;
        }
      }
      next();
    }
  }

});

export default router;
